import { Button, Grid, GridColumn, Heading, Text } from 'telia-front-react';
import React from 'react';
import UiNotice from '../components/UiNotice';
import { observer } from 'mobx-react';
import PersonalCodeBinding from './PersonalCodeBinding';
import { AccountReturnParams } from '../pages/AccountPage';
import Config from '../Config';
import useStores from '../stores/UseStores';

const TOP_NOTICES = [
  'merge.add-personal-code.success',
  'merge.add-personal-code.error',
  'merge.add-personal-code.cancelled',
  'reset_password.success',
  'accountMerge.success',
  'error.general',
  'passkey.register.success',
  'passkey.register.error',
  'passkey.delete.success',
  'passkey.delete.error',
];

interface AccountPageHeaderProps {
  returnParams: AccountReturnParams;
}

const AccountPageHeader = observer((props: AccountPageHeaderProps): React.JSX.Element => {
  const { returnParams } = props;
  const {
    accountInfoStore: { firstName, lastName, showAddPersonalCodeButton, personalCode, personalCodeCountryCode },
    routeStore: { route, getParameter },
    translateStore: { translate },
    languageStore: { currentLanguage },
  } = useStores();

  const renderReturnButtonAndTitle = () => {
    const handleButtonClick = () => {
      let routeUrl;
      const app = `${getParameter('app') || window.location.hostname.split('.')[1]}`;

      switch (app) {
        case 'diil':
          routeUrl = Config.diilSelfServiceUrl;
          break;
        case 'super':
          routeUrl = currentLanguage !== 'et' ? `${Config.superUrl}/${currentLanguage}` : Config.superUrl;
          break;
        case 'telia':
        default:
          routeUrl = Config.selfServiceUrl;
      }
      route(routeUrl);
    };

    return (
      <Grid align={['middle-xs']} noWrap={true}>
        <GridColumn width={['min']}>
          <Button icon="#arrow-left" text={translate('button.back')} variant="secondary" onClick={handleButtonClick} />
        </GridColumn>
        <GridColumn width={['max']}>
          <Heading className="h2 text-primary" element="h1">
            {translate('accountPage.title')}
          </Heading>
        </GridColumn>
      </Grid>
    );
  };

  const renderItem = (title: string, value: string) => {
    return (
      <p>
        <span className="text-small text-light">{title}</span>
        <br />
        <span className="text-bold">{value}</span>
      </p>
    );
  };

  const getName = () => {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return firstName || lastName || '-';
  };

  const renderPersonalInfo = () => {
    return (
      <Grid>
        <GridColumn width={['xs-12', 'sm-4', 'md-3', 'lg-2']}>{renderItem(translate('accountPage.name'), getName())}</GridColumn>
        {showAddPersonalCodeButton ? (
          <GridColumn width={['xs-12', 'min-sm']}>{<PersonalCodeBinding returnParams={returnParams} />}</GridColumn>
        ) : (
          <>
            <GridColumn width={['xs-12', 'sm-4', 'md-3', 'lg-2']}>{renderItem(translate('accountPage.personalCode'), personalCode)}</GridColumn>
            <GridColumn width={['xs-12', 'sm-4', 'md-3', 'lg-2']}>
              {renderItem(translate('accountPage.personalCodeCountry'), translate(`accountPage.personalCodeCountry.${personalCodeCountryCode}`))}
            </GridColumn>
          </>
        )}
      </Grid>
    );
  };

  return (
    <Grid>
      <GridColumn width={['xs-12']}>
        <Text>
          {renderReturnButtonAndTitle()}
          {renderPersonalInfo()}
          <p className="text__margin-double">{translate('accountPage.header.introduction')}</p>
          <UiNotice only={TOP_NOTICES} />
        </Text>
      </GridColumn>
    </Grid>
  );
});

export default AccountPageHeader;
